// src/hooks/useCheckUpdate.js
import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { UpdateCheck } from '../Action/UpdateCheck';
import { GetCookie } from '../Action/GetCookie';
import { SetUpdate, SetUpdateVersion } from '../app/Home';

const useCheckUpdate = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    // console.log('update check')
    const checkUpdate = async () => {
      const updateRes = await UpdateCheck();
      const dismissedVersion = GetCookie('DissMissUpdateVersion');

      dispatch(SetUpdateVersion(updateRes.version));

      if (updateRes.status && Number(dismissedVersion) !== updateRes.version) {
        dispatch(SetUpdate(true));
      }
    };

    checkUpdate();
  }, [dispatch]);
};

export default useCheckUpdate;
